import React, { useState } from 'react';

import { useTranslation } from 'react-i18next';

import StaffTravelFilters from './components/StaffTravelFilters';
import StaffTravelList from './components/StaffTravelList';
import { IFilters } from './types';
import { downloadStaffTravel, fetchStaffTravel } from '../../api/staff-travel';
import ContentWrapper from '../../components/ContentWrapper';
import ProgressSection from '../../components/ProgressSection';
import { IStaffTravel } from '../../types/staff-travel.type';
import { HttpUtils } from '../../utils/http.utils';

const StaffTravel = React.memo(() => {
  const [travel, setTravel] = useState<IStaffTravel[]>([]);
  const [isSubmitProcess, setSubmitProcess] = useState<boolean>(false);
  const [isExportProcess, setExportProcess] = useState<boolean>(false);
  const [isReady, setReady] = useState<boolean>(false);

  const { t } = useTranslation();

  const handleSubmit = React.useCallback(
    (filters: IFilters) => {
      setSubmitProcess(true);

      if (!isReady) {
        setReady(true);
      }

      fetchStaffTravel(filters)
        .then((response) => {
          setTravel(response);
        })
        .catch(() => setTravel([]))
        .finally(() => setSubmitProcess(false));
    },
    [isReady],
  );

  const handleExport = React.useCallback(
    (filters: IFilters) => {
      setExportProcess(true);

      if (!isReady) {
        setReady(true);
      }

      downloadStaffTravel(filters)
        .then((response) => HttpUtils.handleBlob(response, 'staff_travel.xlsx'))
        .finally(() => setExportProcess(false));
    },
    [isReady],
  );

  const renderList = React.useMemo(() => {
    if (!isReady) {
      return null;
    }

    if (isSubmitProcess) {
      return <ProgressSection mt={3} />;
    }

    return <StaffTravelList travel={travel} />;
  }, [travel, isReady, isSubmitProcess]);

  return (
    <ContentWrapper title={t('staff_travel.title')}>
      <StaffTravelFilters
        onSubmit={handleSubmit}
        onExport={handleExport}
        isSubmitProcess={isSubmitProcess}
        isExportProcess={isExportProcess}
      />

      {renderList}
    </ContentWrapper>
  );
});

export default StaffTravel;
